export default __webpack_public_path__ + "static/media/pbs.7c357191.png";